import { r_maxLength } from '../validation/restrictions';
import {
  required,
  alphanumericWithHyphen,
  textOnly,
  alphanumericWithHyphenAndSpace,
  maxLength,
  minLength,
  regexValidation,
  exactLength,
  number
} from '../validation';
import { API_URL } from '../config';
import { isValidBeneAddressInput } from '../../screens/beneficiary-flow/pages/recipient-address/utils/methods';

/**
 * Address template for AU
 * @type {*[]}
 */

export const validationConfig = {
  onlytext: textOnly,
  alphanumericWithHyphen: alphanumericWithHyphen,
  alphanumericWithHyphenAndSpace: alphanumericWithHyphenAndSpace,
  number: number
};

export function getValidation(validation, fieldType, isBeneAddressFlow = false) {
  const validationArr = [];
  if (validation?.required) {
    validationArr.push(required);
    if (isBeneAddressFlow) validationArr.push(isValidBeneAddressInput);
  }
  validation?.type &&
    validationConfig[validation.type] &&
    validationArr.push(validationConfig[validation.type]);
  validation?.regex &&
    validationArr.push(regexValidation(validation.regex, validation.error_message));
  validation?.length?.max && validationArr.push(maxLength(validation.length.max));
  validation?.length?.min && validationArr.push(minLength(validation.length.min, fieldType));
  validation?.length?.exact &&
    validationArr.push(exactLength(validation.length.exact));
  return validationArr;
}

export function getAddressData(
  addressConfigTemp,
  isRevampedFlow = false,
  isBeneAddressFlow = false,
  isBeneSchemaEnabled = false
) {
  const addressField = [];
  const addressConfig =
    isBeneAddressFlow && isBeneSchemaEnabled
      ? addressConfigTemp['address_details']
      : addressConfigTemp;

  if (addressConfig && typeof addressConfig === 'object') {
    Object.keys(addressConfig).forEach((key) => {
      const item = addressConfig[key];
      const fromField = {
        field: item?.render?.value_field_name,
        validate: getValidation(item.validation, item?.render?.value_field_name),
        normalize: isRevampedFlow
          ? undefined
          : item?.validation?.length?.max && r_maxLength(item.validation.length.max),
        placeholder: item?.render?.label,
        type: item?.render?.type || item?.render?.field,
        visible:
          item?.render?.visible !== undefined ? item?.render?.visible : item?.render?.visibility,
        sequence: item?.render?.sequence,
        editable: !item?.render?.disabled,
        url: item?.render?.url && `${API_URL}${item?.render?.url}`,
        tooltip: item?.render?.tooltip,
        maxLength: item?.validation?.length?.max || item?.validation?.length?.max_length,
        minLength: item?.validation?.length?.min || item?.validation?.length?.min_length
      };
      if (item.render && item.render.sequence !== undefined) {
        addressField[item.render.sequence] = fromField;
      } else {
        addressField.push(fromField);
      }
      return key;
    });
  }
  return addressField;
}

export function getAddressDataForBeneFlow(addressConfig) {
  const addressField = [];
  if (addressConfig && typeof addressConfig === 'object') {
    Object.keys(addressConfig).forEach((key) => {
      const item = addressConfig[key];
      const fromField = {
        field: item?.name,
        validate: getValidation(item?.validations, item?.name, true),
        normalize: item?.validations?.length?.max
          ? r_maxLength(item.validations.length.max)
          : undefined,
        placeholder: item?.label,
        type: item?.type,
        url: item?.url ? `${API_URL}${item?.url}` : undefined,
        maxLength: item?.validations?.length?.max || item?.validations?.length?.max_length,
        minLength: item?.validations?.length?.min || item?.validations?.length?.min_length
      };
      addressField.push(fromField);
    });
  }
  return addressField;
}

export function isDefaultAddress(countryCode) {
  switch (countryCode) {
    case 'AU':
    case 'SG':
    case 'MY':
    case 'HK':
    case 'US':
    case 'CA':
    case 'IN':
    case 'DE':
    case 'NL':
    case 'IT':
      return false;
    default:
      return true;
  }
}

export const VALID_ADDRESS_FIELDS = {
  unit_number: '',
  street_number: '',
  street: '',
  street_name: '',
  street_type: '',
  suburb: '',
  state: '',
  block_number: '',
  floor_number: '',
  building_name: '',
  district: '',
  address1: '',
  address2: '',
  city: '',
  postcode: '',
  province: ''
};
